module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image01-1110x550.ab52f27b.jpg";